/* ============================================================================
   mazo-review-form.js — the "Rate this product" dialog (2026-10-06, Judge.me). Styles: mazo-review-dialog.css.
   Opened by mazo-reviews.js: window.mazoReviewForm.open(rootEl).

   WHY OUR OWN DIALOG IN FRONT OF JUDGE.ME'S FORM. The dialog opens with no star picked and Submit disabled; a star
   reveals the optional parts (feedback, photos, About you) on the same screen; Submit; a thank-you with a tick.
   Judge.me's form on the Free plan has a different order, fixed texts and its own look. So the shopper uses THIS dialog, and
   on Submit it fills Judge.me's real form (rendered by the hidden Review Widget in sections/mazo-reviews.liquid)
   and presses Judge.me's own Submit. Judge.me then does everything a review needs: buyer matching, spam checks,
   moderation. Nothing is posted to any undocumented endpoint.
   2026-10-07: the confirmation email is OFF (Judge.me > Settings > "Don't verify", owner's choice), so the texts
   below no longer mention one. Turning it back on means changing the note and the thank-you text again.
   2026-10-08 (owner rules, X25/X26): ONE screen. Only the stars are required. Feedback and photos are optional.
   Name is required only when feedback is written. Email is optional. A stars-only review counts in the score but
   never makes a card (mazo-review-card.liquid and mazo-reviews.js skip a review with no text and no photo).
   Judge.me's form still REQUIRES a name and an email (measured: `required` on both), so when the shopper leaves
   them out we send: name "Anonymous" with Judge.me's own "Post review as anonymous" box ticked, and a unique
   plus-address on mazo's Gmail (ANON_EMAIL). Gmail delivers every plus-address, so Judge.me never bounces on it;
   such a review simply stays unverified (no order match), which is the honest state for it.
   ⚠️ FALLBACK: if Judge.me's form cannot be found, or a step of the hand-off fails, this dialog closes and Judge.me's
   own form is shown, so a review can always be written. Selectors used are listed in JM below; re-check them after
   a Judge.me update (they are its stable BEM classes, measured on 2026-10-06).
   ============================================================================ */
(function () {
  'use strict';
  var JM = {
    modal: '.jdgm-write-review-modal',
    openBtn: '.mazo-revs__jm button, .mazo-revs__jm a',
    introStars: '.jdgm-write-review-modal__section--review-form-intro .jdgm-star',
    slider: '.jdgm-write-review-modal__section--slider',
    submit: '.jdgm-write-review-modal__nav-btn-next',
    thanks: '.jdgm-write-review-modal__section--page--thank-you',
    close: '.jdgm-write-review-modal__close-btn',
    media: 'input.jdgm-write-review-modal__media-input',
    anon: '#jdgm-anonymous-checkbox'
  };
  var MAX_FILES = 5, MAX_MB = 5;
  var ANON_EMAIL = ['mazo.works+review-', '@gmail.com'];   // + a random tag per review; see the header
  var TICK = '<svg class="mazo-rd__tick" viewBox="0 0 56 56" width="56" height="56" fill="none" aria-hidden="true">' +
    '<circle cx="28" cy="28" r="27" class="mazo-rd__tickring"/><path d="M17 29l7.5 7.5L39 21" class="mazo-rd__tickmark"/></svg>';
  var el = null, root = null, rating = 0, files = [], lastFocus = null, busy = false;

  function star() {
    var t = document.getElementById('MazoStarTemplate');
    return t ? t.innerHTML.trim() : '';
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var X = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var BACK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var PHOTO = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="9" cy="10" r="1.6"/><path d="M21 15.5l-4.5-4.5L9 18.5M16 3.5v4M14 5.5h4"/></svg>';

  function build() {
    var title = esc(root.getAttribute('data-product-title'));
    var img = root.getAttribute('data-product-image');
    var product = '<div class="mazo-rd__product">' + (img ? '<img src="' + esc(img) + '" alt="" width="170" height="220">' : '') +
      '<span class="mazo-rd__ptitle">' + title + '</span></div>';
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += '<label class="mazo-rd__star"><input type="radio" name="mazo-rd-rate" value="' + i + '" class="visually-hidden">' +
        '<span class="visually-hidden">' + i + (i === 1 ? ' star' : ' stars') + '</span>' + star() + '</label>';
    }
    el = document.createElement('div');
    el.className = 'mazo-rd';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'MazoRdTitle');
    el.innerHTML =
      '<div class="mazo-rd__scrim" data-rd-close></div>' +
      '<div class="mazo-rd__panel" data-mazo-edge="card">' +
        '<button type="button" class="mazo-rd__icon mazo-rd__close" data-rd-close aria-label="Close">' + X + '</button>' +
        '<div class="mazo-rd__step" data-rd-step="1">' +
          '<h2 class="mazo-rd__title" id="MazoRdTitle">Write a review</h2>' +
          '<div class="mazo-rd__body">' + product +
            '<div class="mazo-rd__content">' +
              '<fieldset class="mazo-rd__rate"><legend class="mazo-rd__label">Your rating<span class="mazo-rd__tag mazo-rd__tag--req">Required</span></legend>' +
                '<div class="mazo-rd__stars">' + stars + '</div></fieldset>' +
              '<p class="mazo-rd__hint" data-rd-hint>Tap a star. That is all we need.</p>' +
              '<div class="mazo-rd__more" hidden>' +
                '<div class="mazo-rd__group">' +
                  '<div class="mazo-rd__field"><label class="mazo-rd__label" for="MazoRdText">Feedback<span class="mazo-rd__tag">Optional</span></label>' +
                    '<textarea class="mazo-rd__input mazo-rd__textarea" id="MazoRdText" rows="3" maxlength="5000" placeholder="How does it fit, feel and wash?"></textarea></div>' +
                  '<div class="mazo-rd__field"><span class="mazo-rd__label">Photos<span class="mazo-rd__tag">Optional</span></span>' +
                    '<label class="mazo-rd__drop"><input type="file" accept="image/gif,image/jpeg,image/png" multiple class="mazo-rd__file" aria-label="Add photos">' +
                    PHOTO + '<span class="mazo-rd__droptext">Add up to ' + MAX_FILES + ' photos</span><span class="mazo-rd__dropnote">.jpg, .png or .gif, up to ' + MAX_MB + 'MB each</span></label>' +
                    '<div class="mazo-rd__thumbs"></div></div>' +
                '</div>' +
                '<div class="mazo-rd__group">' +
                  '<p class="mazo-rd__gtitle">About you</p>' +
                  '<div class="mazo-rd__field"><label class="mazo-rd__label" for="MazoRdName">Name<span class="mazo-rd__tag" data-rd-nametag>Optional</span></label>' +
                    '<input class="mazo-rd__input" id="MazoRdName" type="text" autocomplete="name" maxlength="80" placeholder="Shown with your review"></div>' +
                  '<div class="mazo-rd__field"><label class="mazo-rd__label" for="MazoRdEmail">Email<span class="mazo-rd__tag">Optional</span></label>' +
                    '<input class="mazo-rd__input" id="MazoRdEmail" type="email" autocomplete="email" inputmode="email" placeholder="you@example.com">' +
                    '<p class="mazo-rd__note">Only used to match your review to your order. It is never shown.</p></div>' +
                '</div>' +
              '</div>' +
              '<p class="mazo-rd__error" data-rd-error role="alert" hidden></p>' +
              '<button type="button" class="mazo-rd__btn" data-rd-submit disabled>Submit</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="mazo-rd__step mazo-rd__step--done" data-rd-step="3" hidden>' + TICK +
          '<h2 class="mazo-rd__title">Thank you</h2>' +
          '<p class="mazo-rd__done">Your review is in. It will show here once it is published.</p>' +
          '<button type="button" class="mazo-rd__btn" data-rd-close>Close</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', onClick);
    el.addEventListener('change', onChange);
    el.addEventListener('input', function (e) { if (e.target.id === 'MazoRdText' || e.target.id === 'MazoRdName') syncName(); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function step(n) {
    [].forEach.call(el.querySelectorAll('[data-rd-step]'), function (s) { s.hidden = s.getAttribute('data-rd-step') !== String(n); });
    el.setAttribute('data-step', n);
    var f = el.querySelector('[data-rd-step="' + n + '"] input, [data-rd-step="' + n + '"] button');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function setRating(v) {
    rating = v;
    [].forEach.call(el.querySelectorAll('.mazo-rd__star'), function (l, i) { l.classList.toggle('is-on', i < v); });
    el.querySelector('.mazo-rd__more').hidden = !v;
    el.querySelector('[data-rd-hint]').textContent = v ? 'Rated ' + v + ' out of 5. Add more below if you like.' : 'Tap a star. That is all we need.';
    el.querySelector('[data-rd-submit]').disabled = !v;
  }
  // Name is required only once feedback is written (owner rule 2026-10-08); the tag says which, live
  function nameNeeded() { return !!el.querySelector('#MazoRdText').value.trim(); }
  function syncName() {
    var need = nameNeeded(), tag = el.querySelector('[data-rd-nametag]'), inp = el.querySelector('#MazoRdName');
    tag.textContent = need ? 'Needed with feedback' : 'Optional';
    tag.classList.toggle('mazo-rd__tag--req', need);
    inp.required = need;
    if (!need || inp.value.trim()) showError('');
  }
  function renderThumbs() {
    var box = el.querySelector('.mazo-rd__thumbs');
    box.innerHTML = files.map(function (f, i) {
      return '<span class="mazo-rd__thumb"><img src="' + URL.createObjectURL(f) + '" alt=""><button type="button" class="mazo-rd__thumbx" data-rd-rm="' + i + '" aria-label="Remove photo">' + X + '</button></span>';
    }).join('');
  }
  function onChange(e) {
    if (e.target.name === 'mazo-rd-rate') setRating(parseInt(e.target.value, 10) || 0);
    if (e.target.classList.contains('mazo-rd__file')) {
      [].forEach.call(e.target.files || [], function (f) {
        if (files.length >= MAX_FILES) return;
        if (!/^image\/(gif|jpeg|png)$/.test(f.type) || f.size > MAX_MB * 1048576) return;
        files.push(f);
      });
      e.target.value = '';
      renderThumbs();
    }
  }
  function showError(msg) { var p = el.querySelector('[data-rd-error]'); p.textContent = msg || ''; p.hidden = !msg; }
  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-rd-close]')) { close(); return; }
    var rm = t.closest('[data-rd-rm]');
    if (rm) { files.splice(parseInt(rm.getAttribute('data-rd-rm'), 10), 1); renderThumbs(); return; }
    if (t.closest('[data-rd-submit]')) submit();
  }

  /* ---------- the hand-off to Judge.me's own form ---------- */
  function wait(test, ms) {
    return new Promise(function (res, rej) {
      var t0 = Date.now();
      (function tick() {
        var v = test();
        if (v) return res(v);
        if (Date.now() - t0 > ms) return rej(new Error('timeout'));
        setTimeout(tick, 120);
      })();
    });
  }
  function setVal(input, v) {
    var proto = input.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(input, v);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function fieldByLabel(scope, re) {
    var labels = scope.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if (!re.test(labels[i].textContent || '')) continue;
      var id = labels[i].getAttribute('for');
      var f = (id && document.getElementById(id)) || labels[i].parentElement.querySelector('input:not([type=checkbox]):not([type=file]), textarea');
      if (f) return f;
    }
    return null;
  }
  function jmOpen() {
    document.documentElement.classList.add('mazo-rd-proxy');
    var m = document.querySelector(JM.modal);
    var visible = m && m.offsetParent !== null && getComputedStyle(m).display !== 'none' && m.getBoundingClientRect().height > 0;
    if (!visible) {
      var b = [].filter.call(document.querySelectorAll(JM.openBtn), function (x) { return /write a review/i.test(x.textContent || ''); })[0];
      if (!b) return Promise.reject(new Error('no judge.me button'));
      b.click();
    }
    // ⚠️ Wait until the modal is really OPEN (shown, stars screen current). Its markup is in the page before it
    // opens, and a star clicked before then does nothing (measured 2026-10-06: the hand-off fell back).
    return wait(function () {
      var mm = document.querySelector(JM.modal);
      var intro = document.querySelector('.jdgm-write-review-modal__section--review-form-intro');
      return mm && getComputedStyle(mm).display !== 'none' && intro && /current/.test(intro.className) && document.querySelector(JM.introStars);
    }, 8000);
  }
  function jmClose() {
    var c = document.querySelector(JM.close);
    if (c) c.click();
    setTimeout(function () { document.documentElement.classList.remove('mazo-rd-proxy'); }, 400);
  }
  function submit() {
    if (busy) return;
    if (!rating) { showError('Pick a star rating first.'); return; }
    var name = el.querySelector('#MazoRdName').value.trim();
    var email = el.querySelector('#MazoRdEmail').value.trim();
    if (!name && nameNeeded()) { showError('Please add your name to go with your feedback.'); el.querySelector('#MazoRdName').focus(); return; }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showError('That email does not look right. Fix it or leave it empty.'); el.querySelector('#MazoRdEmail').focus(); return; }
    var anon = !name;
    if (anon) name = 'Anonymous';
    if (!email) email = ANON_EMAIL[0] + Date.now().toString(36) + Math.random().toString(36).slice(2, 6) + ANON_EMAIL[1];
    showError('');
    busy = true;
    var btn = el.querySelector('[data-rd-submit]');
    btn.disabled = true; btn.textContent = 'Sending...';
    var text = el.querySelector('#MazoRdText').value.trim();
    jmOpen().then(function () {
      var stars = document.querySelectorAll(JM.introStars);
      stars[Math.min(rating, stars.length) - 1].click();
      return wait(function () { var s = document.querySelector(JM.slider); return s && /current/.test(s.className) && s.querySelector('textarea') && s; }, 6000);
    }).then(function (slider) {
      // Judge.me's field ids (stable, measured 2026-10-06); label matching is only the fallback
      var ta = document.getElementById('jdgm-review-body-input') || slider.querySelector('textarea');
      if (text && ta) setVal(ta, text);
      var em = document.getElementById('jdgm-email-input') || slider.querySelector('input[type=email]') || fieldByLabel(slider, /email/i);
      var nm = document.getElementById('jdgm-name-input') || fieldByLabel(slider, /display name/i);
      if (!em || !nm) throw new Error('fields');
      setVal(em, email); setVal(nm, name);
      var ab = document.querySelector(JM.anon);
      if (ab && ab.checked !== anon) ab.click();
      if (!files.length) return slider;
      var mi = slider.querySelector(JM.media);
      if (!mi) return slider;
      var dt = new DataTransfer();
      files.forEach(function (f) { dt.items.add(f); });
      mi.files = dt.files;
      mi.dispatchEvent(new Event('change', { bubbles: true }));
      // Judge.me uploads each photo before it accepts the submit: wait until its previews settle
      // done = one thumbnail per photo and no preview still marked `jdgm-is-uploading` (a generic spinner element
      // is always in Judge.me's markup, so it is NOT a signal; measured 2026-10-06)
      return wait(function () {
        var thumbs = slider.querySelectorAll('.jdgm-write-review-modal__media-thumbnail');
        var up = slider.querySelector('.jdgm-is-uploading');
        return thumbs.length >= files.length && !up && slider;
      }, 45000);
    }).then(function (slider) {
      var sub = slider.querySelector(JM.submit) || document.querySelector(JM.submit);
      if (!sub) throw new Error('submit');
      sub.click();
      return wait(function () {
        var th = document.querySelector(JM.thanks);
        if (th && /current/.test(th.className)) return 'ok';
        var err = [].filter.call(document.querySelectorAll(JM.modal + ' [class*="error"]'), function (x) { return x.offsetParent && (x.textContent || '').trim(); })[0];
        return err ? 'error:' + err.textContent.trim() : null;
      }, 20000);
    }).then(function (res) {
      if (res !== 'ok') throw new Error(res);
      jmClose();
      step(3);
    }).catch(function (err) {
      var m = String(err && err.message || '');
      if (m.indexOf('error:') === 0) {
        showError(m.slice(6));
        jmClose();
      } else {
        // could not hand off: show Judge.me's own form so the review is never lost
        close(true);
        document.documentElement.classList.remove('mazo-rd-proxy');
      }
    }).then(function () { busy = false; btn.disabled = false; btn.textContent = 'Submit'; });
  }

  /* ---------- open / close ---------- */
  function open(r) {
    root = r;
    if (!el) build();
    files = []; renderThumbs(); setRating(0); showError('');
    [].forEach.call(el.querySelectorAll('input[name="mazo-rd-rate"]'), function (x) { x.checked = false; });
    el.querySelector('#MazoRdText').value = '';
    el.querySelector('#MazoRdName').value = '';
    el.querySelector('#MazoRdEmail').value = '';
    syncName();
    step(1);
    lastFocus = document.activeElement;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    if (window.mazoScrollLock) window.mazoScrollLock.enable(el.querySelector('.mazo-rd__panel'));
  }
  function close(keepJM) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    if (window.mazoScrollLock) window.mazoScrollLock.disable(el.querySelector('.mazo-rd__panel'));
    setTimeout(function () { el.hidden = true; }, 200);
    if (!keepJM) document.documentElement.classList.remove('mazo-rd-proxy');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.mazoReviewForm = { open: open, close: close };
})();
